import { Setting, UIConfig, UIConfigKey } from '@/features/auth/types/setting'
import client from '@/shared/apis/client'
import { AxiosPromise } from 'axios'

export const updateSetting = (
  key: keyof Setting,
  value: Setting[keyof Setting]
): AxiosPromise<string> => {
  const params = { value }
  return client.patch(`/api/users/me/custom_setting/${key}/`, params)
}

// ui_config は GET では envelope に nest されるが、 書込みは flat key
// (font_size / improvements_expanded) を同 PATCH endpoint へ送る.
export const updateUIConfig = (
  key: UIConfigKey,
  value: UIConfig[UIConfigKey]
): AxiosPromise<string> => {
  return client.patch(`/api/users/me/custom_setting/${key}/`, { value })
}

export const getCustomSetting = (): AxiosPromise<Setting> => {
  return client.get('/api/users/me/custom_setting/')
}
